import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ComposedChart,
    Text,
} from "recharts";
import Legend from '../Legend/Legend'
import { formatNumberWithCommas } from '../../../utils/utils';

const getPath = (x, y, width, height, radius = 6) => {
  const isNegative = width < 0;
  const barWidth = Math.abs(width);
  const r = Math.min(radius, barWidth / 2, height / 2);

  if (!isNegative) {
    return `
      M${x},${y}
      H${x + barWidth - r}
      A${r},${r} 0 0 1 ${x + barWidth},${y + r}
      V${y + height - r}
      A${r},${r} 0 0 1 ${x + barWidth - r},${y + height}
      H${x}
      Z
    `;
  }

  const startX = x - barWidth;

  return `
    M${x},${y}
    H${startX + r}
    A${r},${r} 0 0 0 ${startX},${y + r}
    V${y + height - r}
    A${r},${r} 0 0 0 ${startX + r},${y + height}
    H${x}
    Z
  `;
};


const CircularBar = ({ fill, x, y, width, height, value }) => {
  const isNegative = value < 0;
  const barEndX = isNegative
    ? x - Math.abs(width)  
    : x + width;            

  return (
    <>
      <path
        d={getPath(x, y, width, height)}
        fill={fill}
      />

      <text
        x={isNegative ? barEndX - 6 : barEndX + 6}
        y={y + height / 2}
        textAnchor={isNegative ? "end" : "start"}
        dominantBaseline="middle"
        fontSize="12"
        fill="#333"
      >
        {formatNumberWithCommas(value)}
      </text>
    </>
  );
};




const formatToCurrency = (value) => {
    if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`; // Convert to millions
    if (value >= 1_000) return `$${(value / 1_000).toFixed(1)}K`; // Convert to thousands
    return `$${value}`; // Otherwise, just return the value
};

const calculateMaxValue = (data, keys) => {
    if (!Array.isArray(data)) return 0; // Ensure data is an array
    return Math.max(
      ...data.map((item) => 
        Math.max(
          ...keys.map((key) => {
            const value = parseFloat(item[key]); // Parse values as numbers
            return isNaN(value) ? 0 : value; // Default to 0 if value is NaN
          })
        )
      )
    );
  };

const CoManChart = ({ data, xAxisLabel, xPrimaryDataKey = "Number of Contracts", xSecodaryDataKey = "Contract Spend", yDataKey = "name", title1 = "", title2 = "" }) => {
 
    const maxPrimaryValue = calculateMaxValue(data, [xPrimaryDataKey]); 
    const maxSecondaryValue = calculateMaxValue(data, [xSecodaryDataKey]);
    const roundUpToNearest25 = (value) => Math.ceil(value / 25) * 25;
    const chartMaxValue = roundUpToNearest25(Math.max(maxPrimaryValue,maxSecondaryValue)*1.2);
    const minValue = Math.min(
    0,
    ...data.map(d => Number(d[xPrimaryDataKey])),
    ...data.map(d => Number(d[xSecodaryDataKey]))
    );



    return (
        <div style={{ width: "100%", maxHeight:"350px", minHeight:"180px", overflowY: "auto" }}>
            {/* { height: "280px", minHeight:"150px",} */}
            <div style={{ width: '100%', height: `${data.length * 50}px` }}>
                <ResponsiveContainer width="100%" height={"100%"} minHeight={"150px"} >
                    <ComposedChart
                        layout="vertical"
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            bottom: 25,
                            left: 40,
                        }}
                    >
                        <CartesianGrid horizontal={false} vertical={true} />
                        <XAxis dataKey={xPrimaryDataKey} 
                            label={{ value: xAxisLabel, offset: 9, position: "bottom", fill: '#616161' }} 
                            type="number"
                            // domain={[0, Math.round(chartMaxValue)]} // * 1.2
                            domain={[minValue * 1.2, chartMaxValue * 1.2]}
                            axisLine={false} tickLine={false}
                            ticks={[...Array(6)].map((_, i) => Math.round((Math.round(chartMaxValue) / 5) * i))} // * 1.2
                            tickFormatter={formatNumberWithCommas} />
                        <YAxis dataKey={yDataKey} tick={{ fontSize: 15 }} type="category" scale="auto" axisLine={false} tickLine={false} width={100} />
                        <Bar
                            dataKey={xPrimaryDataKey}
                            shape={<CircularBar />}
                            barSize={10}
                            fill="#0078A7"
                        />
                        <Bar
                            dataKey={xSecodaryDataKey}
                            shape={<CircularBar />}
                            barSize={10}
                            fill="#B05788"
                        />
                    </ComposedChart>
                </ResponsiveContainer>  
            </div>
                {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "14px" }}>
                    <Legend title1={title1} title2={title2} />
                </div>   */}
        </div>
    );
};

export default CoManChart;
